import { type CornerCountersinkHoles, type CountersinkHole } from 'metalworks-domain'

import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { AnchorPointsToggle } from '../AnchorPointsToggle'
import { GenericDistancePropertyContainerItem } from './GenericDistancePropertyPage'

interface Props {
  id: CountersinkHole['id'] | CornerCountersinkHoles['id']
  disableAnchorSwitching?: boolean
}

export const CountersinkHolePropertyPage = (props: Props) => {
  const { id, disableAnchorSwitching } = props

  return (
    <PropertyContainer.Group spacing="large">
      <GenericDistancePropertyContainerItem id={id} />
      {disableAnchorSwitching !== true && <AnchorPointsToggle />}
    </PropertyContainer.Group>
  )
}
